import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { buildSubscriptionEmailPreview, formatPreviewValue } from './subscriptionEmailPreview';
import SubscriptionSlotsPatternTable from '../SubscriptionSlotsPattern/SubscriptionSlotsPatternTable';
import './SubscriptionSummaryPreviewModal.css';

const PreviewSection = ({ title, rows }) => (
  <section className="mp-subscription-email-preview__section">
    <h3>{title}</h3>
    <table className="mp-subscription-email-preview__table">
      <tbody>
        {rows.map(([label, value]) => (
          <tr key={label}>
            <th scope="row">{label}</th>
            <td>{formatPreviewValue(value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
);

const SubscriptionSummaryPreviewModal = ({
  open,
  onClose,
  payload,
  subscriptionId = '',
  lookupCode = '',
  slotLabelById = {},
}) => {
  if (!open || !payload) return null;

  const preview = buildSubscriptionEmailPreview({
    payload,
    subscriptionId,
    lookupCode,
    slotLabelById,
  });

  return (
    <div
      className="mp-product-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mp-subscription-email-preview-title"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="mp-subscription-email-preview">
        <div className="mp-product-modal__header">
          <div>
            <h3 id="mp-subscription-email-preview-title">Subscription Summary</h3>
            <p>Review your plan details before confirming. Your confirmation email will include the same summary.</p>
          </div>
          <button type="button" className="mp-product-modal__close" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>

        <div className="mp-subscription-email-preview__body">
          <div className="mp-subscription-email-preview__banner">
            <strong>Subscription summary</strong>
            <span>Customer name and contact details are listed below under Your Details.</span>
          </div>

          <PreviewSection title="Reference" rows={preview.referenceRows} />
          <PreviewSection title="Your Details" rows={preview.customerRows} />
          <PreviewSection title="Subscription Details" rows={preview.subscriptionRows} />

          <section className="mp-subscription-email-preview__section">
            <h3>Meal slots &amp; pattern</h3>
            <SubscriptionSlotsPatternTable rows={preview.slotPatternRows} />
          </section>

          <PreviewSection title="Charges & totals" rows={preview.chargeRows} />

          <section className="mp-subscription-email-preview__section">
            <h3>Selected Products</h3>
            {preview.productLines.length ? (
              <ul className="mp-subscription-email-preview__products">
                {preview.productLines.map((product, index) => (
                  <li key={`${product.line}-${index}`}>
                    <span>{product.line}</span>
                    {product.meta ? <small>{product.meta}</small> : null}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="mp-subscription-email-preview__empty">No products selected.</p>
            )}
          </section>

          {preview.itemScheduleLines.length ? (
            <section className="mp-subscription-email-preview__section">
              <h3>Item delivery schedules</h3>
              <ul className="mp-subscription-email-preview__products">
                {preview.itemScheduleLines.map((row) => (
                  <li key={row}><span>{row}</span></li>
                ))}
              </ul>
            </section>
          ) : null}

          <div className="mp-subscription-email-preview__footer">
            <p>Digirasa · Miyapur, Hyderabad – 500049</p>
            <p>
              <a href="tel:+918143231857">+91 81432 31857</a>
              {' · '}
              <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSummaryPreviewModal;
